export type AccountNavigationItem = {
  label: string;
  to: string;
};

// Later account slices extend this released-destination list in one place.
// A03 deliberately exposes no links to profile, address, wishlist, or order
// routes until those vertical slices exist.
export const accountNavigationItems: readonly AccountNavigationItem[] = [
  { label: "Overview", to: "/account" },
  { label: "Personal details", to: "/account/profile" },
  { label: "Addresses", to: "/account/addresses" },
  { label: "Security", to: "/account/security" },
  { label: "Favorites", to: "/account/wishlist" },
  { label: "Orders", to: "/account/orders" },
];
